import React from 'react'
import ProductionItemsIndex from '../features/productionItems'
function ProductionItemsPage() {
  return (
    <ProductionItemsIndex />
  )
}

export default ProductionItemsPage